const API_ORIGIN = (process.env.REACT_APP_API_URL || "https://validator.trustbitcoin.io").replace(/\/$/, "");

export const assetUrl = (process.env.REACT_APP_ASSET_URL || `${API_ORIGIN}/`).replace(/\/?$/, "/");

export function getToken() {
  const value = localStorage.getItem("token");

  if(!value) return "";

  try {
    return JSON.parse(value);
  } catch(_) {
    return value;
  }
}

export function clearAuth() {
  localStorage.removeItem("token");
  sessionStorage.removeItem("user");
  sessionStorage.removeItem("isLogin");
  window.dispatchEvent(new Event("auth:changed"));
}

export function saveAuth(data) {
  localStorage.setItem("token", data.token);
  sessionStorage.setItem("user", JSON.stringify(data.user));
  sessionStorage.setItem("isLogin", "true");
  window.dispatchEvent(new Event("auth:changed"));
}

export async function apiRequest(path, options = {}) {
  const token = getToken();
  const isFormData = options.body instanceof FormData;

  const response = await fetch(`${API_ORIGIN}/api/${String(path).replace(/^\/+/, "")}`, {
    ...options,
    headers: {
      Accept: "application/json",
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {})
    }
  });

  const body = await response.json().catch(() => ({}));

  if(response.status === 401) clearAuth();

  if(!response.ok) {
    const validation = body.errors ? Object.values(body.errors).flat()[0] : null;
    const error = new Error(validation || body.message || "Request failed.");

    error.status = response.status;
    error.body = body;

    throw error;
  }

  return body;
}

export async function walletLogin(provider) {
  const accounts = await provider.request({ method: "eth_requestAccounts" });
  const address = String(accounts[0] || "").toLowerCase();
  
  if(!/^0x[a-f0-9]{40}$/.test(address)) throw new Error("Invalid wallet address.");

  const challenge = await apiRequest("auth/wallet/challenge", {
    method: "POST",
    body: JSON.stringify({ address })
  });

  const signature = await provider.request({
    method: "personal_sign",
    params: [challenge.data.message_to_sign, address]
  });

  const verified = await apiRequest("auth/wallet/verify", {
    method: "POST",
    body: JSON.stringify({
      challenge_id: challenge.data.challenge_id,
      address,
      signature
    })
  });

  saveAuth(verified.data);

  return verified.data;
}

export async function logoutApi() {
  try {
    await apiRequest("auth/logout", { method: "POST" });
  } finally {
    clearAuth();
  }
}

export async function privateDocumentUrl(documentId, side) {
  const token = getToken();

  const response = await fetch(`${API_ORIGIN}/api/traveler-documents/${documentId}/${side}`, {
    headers: {
      Accept: "application/octet-stream",
      Authorization: `Bearer ${token}`
    }
  });

  if(!response.ok) throw new Error("Unable to load private document.");

  return URL.createObjectURL(await response.blob());
}